import { Plus, Trash2 } from 'lucide-react';

const TYPES = [
  { value: 'per_hour', label: "À l'heure" },
  { value: 'flat', label: 'Forfait' },
  { value: 'per_unit', label: 'À l\u2019unité' },
  { value: 'per_km', label: 'Au km' },
];
const inputCls = 'w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white focus:border-amber-500 focus:outline-none';

export const PriceChartSection = ({ config, setConfig }) => {
  const chart = config.price_chart || [];
  const setChart = (next) => setConfig(prev => ({ ...prev, price_chart: next }));
  const num = (v) => (v === '' ? null : Number(v));

  return (
    <div className="border-t border-slate-800 pt-4 space-y-3" data-testid="price-chart-section">
      <div>
        <p className="text-xs text-amber-400 font-semibold uppercase">Charte de prix de l'atelier</p>
        <p className="text-[11px] text-slate-500">S'applique à tous les clients. Les gros clients peuvent avoir une réduction fidélité dans leur fiche.</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <label className="text-xs text-slate-400 block">Taux horaire main-d'œuvre ($/h)
          <input type="number" step="0.5" min="0" value={config.labor_rate ?? ''} placeholder="ex. 125"
            onChange={e => setConfig(prev => ({ ...prev, labor_rate: num(e.target.value) }))} className={`${inputCls} mt-1`} data-testid="config-labor-rate" />
        </label>
        <label className="text-xs text-slate-400 block">Majoration des pièces (%)
          <input type="number" step="0.5" min="0" value={config.parts_markup_percent ?? ''} placeholder="0"
            onChange={e => setConfig(prev => ({ ...prev, parts_markup_percent: num(e.target.value) }))} className={`${inputCls} mt-1`} data-testid="config-parts-markup" />
        </label>
      </div>
      <p className="text-[11px] text-slate-500">Majoration appliquée au prix coûtant des pièces (scannées ou manuelles) ; seul le prix majoré apparaît sur la facture.</p>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <p className="text-xs text-slate-400">Autres tarifs (forfaits, etc.)</p>
          <button type="button" onClick={() => setChart([...chart, { name: '', type: 'flat', value: 0 }])}
            className="text-xs text-amber-400 flex items-center gap-1" data-testid="chart-add-btn"><Plus size={12} /> Ajouter</button>
        </div>
        {chart.map((p, i) => (
          <div key={i} className="grid grid-cols-[1fr_110px_90px_24px] gap-2 items-center" data-testid={`chart-row-${i}`}>
            <input value={p.name} placeholder="Nom (ex. Changement d'huile)" onChange={e => setChart(chart.map((x, k) => k === i ? { ...x, name: e.target.value } : x))} className={inputCls} data-testid={`chart-name-${i}`} />
            <select value={p.type} onChange={e => setChart(chart.map((x, k) => k === i ? { ...x, type: e.target.value } : x))} className={inputCls}>
              {TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
            <input type="number" step="0.01" value={p.value} onChange={e => setChart(chart.map((x, k) => k === i ? { ...x, value: Number(e.target.value) || 0 } : x))} className={inputCls} data-testid={`chart-value-${i}`} />
            <button type="button" onClick={() => setChart(chart.filter((_, k) => k !== i))} className="text-red-400" data-testid={`chart-remove-${i}`}><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
